export default import.meta.ROLLDOWN_FILE_URL_Xxazh8kNszwnBNd4Smzisw